/**
 * Localizes Drupal `managed_file` widgets in auth (register) flow.
 *
 * The native `<input type="file">` button label and "no file chosen" hint
 * follow the browser locale and cannot be styled or translated through
 * CSS. Instead we wrap each input in a styled trigger label and a sibling
 * filename indicator, keep the native input keyboard-accessible (visually
 * hidden, not display:none), and update the indicator on change.
 */

(function (Drupal, once) {
  'use strict';

  Drupal.behaviors.zkAuthFileInput = {
    attach(context) {
      const inputs = once(
        'zk-auth-file-input',
        '.zk-auth-form .form-managed-file input[type="file"]',
        context
      );

      inputs.forEach((input) => {
        const wrapper = document.createElement('span');
        wrapper.className = 'zk-file-input';

        const trigger = document.createElement('label');
        trigger.className = 'zk-file-input__trigger btn';
        trigger.setAttribute('for', input.id || '');
        trigger.textContent = Drupal.t('Datei auswählen');

        const filename = document.createElement('span');
        filename.className = 'zk-file-input__name';
        filename.textContent = Drupal.t('Keine Datei ausgewählt');

        input.classList.add('zk-file-input__native');

        const parent = input.parentNode;
        if (!parent) {
          return;
        }
        parent.insertBefore(wrapper, input);
        wrapper.appendChild(trigger);
        wrapper.appendChild(input);
        wrapper.appendChild(filename);

        input.addEventListener('change', () => {
          if (input.files && input.files.length > 0) {
            filename.textContent = Array.from(input.files)
              .map((f) => f.name)
              .join(', ');
            filename.classList.add('zk-file-input__name--has-file');
          } else {
            filename.textContent = Drupal.t('Keine Datei ausgewählt');
            filename.classList.remove('zk-file-input__name--has-file');
          }
        });
      });
    },
  };
})(Drupal, once);
